module.exports = __webpack_public_path__ + "static/media/Screenshot 3.abb7d799.JPG";